// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Inbox_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3Zm0 1.5v9.75h-2.69a1.5 1.5 0 0 0-1.06.44l-1.81 1.81h-3.88l-1.81-1.81a1.5 1.5 0 0 0-1.06-.44H4.5V4.5Zm0 15h-15v-3.75h2.69L9 17.56a1.5 1.5 0 0 0 1.06.44h3.88a1.5 1.5 0 0 0 1.06-.44l1.81-1.81h2.69v3.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Inbox_Stroke2_Corner2_Rounded',
})

export const Inbox_Stroke2_Corner2_Rounded_Large = createSinglePathSVG({
  path: 'M52 8H12a4 4 0 0 0-4 4v40a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4Zm0 4v26h-7.175A3.97 3.97 0 0 0 42 39.172L37.172 44H26.829L22 39.172A3.97 3.97 0 0 0 19.172 38H12V12Zm0 40H12V42h7.172L24 46.828A3.97 3.97 0 0 0 26.828 48h10.345A3.97 3.97 0 0 0 40 46.828L44.828 42H52v10Z',
  viewBox: '0 0 64 64',
  glyph: 'Inbox_Stroke2_Corner2_Rounded_Large',
})
